import React from "react";
import { useNavigate } from "react-router-dom";
import { createCurrency } from "adminApi/CurrencyListApi/CurrencyList";
import { validateForm } from "utils/validation";
import { CurrencyRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddCurrencyForm from "./Componate/CurrencyAddForm";
import fields from "../json/CurrencyFields.json"; 
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

/**
 * CurrencyAdd Component
 * Handles the creation of a new system currency with real-time validation and localized data.
 */
const CurrencyAdd = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize form state from JSON field definitions
  const initialValues = formdata.reduce(
    (acc, field) => ({ ...acc, [field.name]: field.default || "" }),
    {}
  );

  const { values, errors, handleChange, setValues } = useFormChange(
    initialValues, 
    CurrencyRules
  );

  /**
   * Form Submission Workflow
   * Validates and sends the currency data to the backend.
   */
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      // Production ready: Send clean JSON object
      return await createCurrency({ 
        data: formValues 
      });
    },
    (vals) => validateForm(vals, CurrencyRules),
    () => navigate(-1),
    "Currency created successfully"
  );

  return (
    <>
      {loadingSubmit && <Spinner isSpinner={true} />}
      <AddCurrencyForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Create Currency"
        setValues={setValues}
      />
    </>
  );
};

export default CurrencyAdd;
